import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-016601c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-check mb-1" }
const _hoisted_2 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dp_field = _resolveComponent("dp-field")!
  const _component_dp_error_message = _resolveComponent("dp-error-message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_dp_field, {
      type: "checkbox",
      value: _ctx.value,
      name: _ctx.name,
      id: `${_ctx.name}-${_ctx.value}`,
      modelValue: _ctx.modelValue,
      class: _normalizeClass(['form-check-input', { 'is-invalid': _ctx.errors[_ctx.name] }]),
      disabled: _ctx.disabled,
      rules: _ctx.rules,
      "onUpdate:modelValue": _ctx.onUpdate
    }, null, 8, ["value", "name", "id", "modelValue", "class", "disabled", "rules", "onUpdate:modelValue"]),
    _createElementVNode("label", {
      for: `${_ctx.name}-${_ctx.value}`
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createVNode(_component_dp_error_message, {
      class: "invalid-feedback d-block",
      name: _ctx.name
    }, null, 8, ["name"])
  ]))
}